import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";

const PropertyStatus = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/propertystatus/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async (name) => {
          try {
            const reqData = { name };
            const { data } = await api("/propertystatus/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, name) => {
          try {
            const reqData = { name };
            const { data } = await api(`/propertystatus/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/propertystatus/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Property Status"
      addRecord="Add Property Status"
      searchRecord="Search Property Status"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{ title: "Property Status" }}
    />
  );
};

export default PropertyStatus;
